import React from 'react';
import { 
  LuCamera,
  LuZap,
  LuMessageCircle,
  LuTag,
  LuClock,
  LuStar
} from 'react-icons/lu';

export const PerformanceTips = () => {
  const tips = [
    {
      id: 1,
      icon: LuCamera,
      text: 'Use high-quality photos with good lighting'
    },
    {
      id: 2,
      icon: LuZap,
      text: 'Boost listings during peak hours for more visibility'
    },
    {
      id: 3,
      icon: LuMessageCircle,
      text: 'Respond to messages within 1 hour for better conversion'
    },
    {
      id: 4,
      icon: LuTag,
      text: 'Price competitively and offer bundle deals'
    },
    {
      id: 5,
      icon: LuClock,
      text: 'Update your store regularly with new listings'
    },
    {
      id: 6,
      icon: LuStar,
      text: 'Ask satisfied customers for reviews and ratings'
    }
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <h2 className="text-lg font-bold text-black mb-4">💡 Boost Your Sales</h2>
      <div className="space-y-4">
        {tips.map((tip) => {
          const Icon = tip.icon;
          return (
            <div key={tip.id} className="flex items-start gap-3 p-3 bg-orange-50 rounded-lg">
              <Icon className="w-5 h-5 text-orange-600 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-gray-900 leading-tight flex-1">
                {tip.text}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PerformanceTips;